import React from 'react'
import PropTypes from 'prop-types'
import Navigation, {
  ProgressiveBlurContainer,
  BlurFilter,
  GradientOverlay,
} from './Navigation'
import Footer from './Footer'
import ParallaxBg from './ParallaxBg'
import CookieNotice from './CookieNotice'
import ThankYouModal from './ThankYouModal'

const Layout = ({ children }) => {
  return (
    <>
      <Navigation />
      <ProgressiveBlurContainer>
        <BlurFilter />
        <BlurFilter />
        <BlurFilter />
        <BlurFilter />
        <BlurFilter />
      </ProgressiveBlurContainer>
      <ParallaxBg />
      {children}
      <Footer />

      <CookieNotice />
      <ThankYouModal />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
